import { render, staticRenderFns } from "./page_type_translations.vue?vue&type=template&id=4c01d1b6&"
import script from "./page_type_translations.vue?vue&type=script&lang=js&"
export * from "./page_type_translations.vue?vue&type=script&lang=js&"
import style0 from "./page_type_translations.vue?vue&type=style&index=0&id=4c01d1b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports